import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
import { Navigate } from "react-router-dom";
import useRequest from "../../../context/useRequest";
import ConfirmationModal from "../../atoms/ConfirmationModal/ConfirmationModal";
import FormCountryCodes from "./FormCountryCodes";

const FormRegister = () => {
    const { data: isRegisterData, sendRequest } = useRequest();
    const [isRegister, setIsRegister] = useState({
        first_name: "",
        last_name: "",
        country_code: "",
        phone: "",
        email: "",
        password: "",
        confirm_password: "",
    });
    const [isRegistered, setIsRegistered] = useState(false);
    const [isFieldErrors, setIsFieldErrors] = useState({})
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        if (isRegisterData && Object.keys(isRegisterData).length > 0) {
            setIsRegister((prev) => {
                return JSON.stringify(prev) === JSON.stringify(isRegisterData) ? prev : { ...prev, ...isRegisterData };
            });
        }
    }, [isRegisterData]);
    const registerHandler = (e) => {
        const { name, value } = e.target;
        if (name === "phone" && !/^\d*$/.test(value)) {

            return;
        }
        if (name === "last_name" | name === "first_name" && !/^[A-Za-z]*$/.test(value)) {

            return;
        }

        setIsRegister((prev) => ({
            ...prev,
            [name]: value,
        }));

        setIsFieldErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };


    const registerSubmitHandler = async (e) => {
        e.preventDefault();
        const formRegister = new FormData();
        formRegister.append("first_name", isRegister.first_name);
        formRegister.append("last_name", isRegister.last_name);
        formRegister.append("email", isRegister.email);
        formRegister.append("country_code", isRegister.country_code);
        formRegister.append("phone", isRegister.phone);
        formRegister.append("password", isRegister.password);
        formRegister.append("confirm_password", isRegister.confirm_password);

        try {
            const response = await sendRequest({
                method: "POST",
                url: "/auth/register",
                body: formRegister,
            });

            if (response) {
                setShowModal(true);
                // alert("Form submitted successfully!");
            } else {
                console.log("Condition failed. Response or data is missing.");
            }
        } catch (error) {
            // console.error("Error response:", error.response);
            if (error.response?.data?.errors) {
                setIsFieldErrors(error.response.data.errors);
            } else {
                alert("An unexpected error occurred.");
            }
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setIsRegistered(true);
    };
    if (isRegistered) {
        return <Navigate to="/login" />;
    }

    return (
        <>
            <form
                onSubmit={registerSubmitHandler}
                className="login-form--item-left-form mt-3"
            >
                <div className="login-form--item-left-form-row">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            value={isRegister.first_name}
                            onChange={registerHandler}
                            className="form-control"
                            label={
                                <span>
                                    First Name<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                            required
                        />
                        {isFieldErrors.first_name && (
                            <p className="error-message">{isFieldErrors.first_name}</p>
                        )}
                    </div>
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={isRegister.last_name}
                            onChange={registerHandler}
                            className="form-control"
                            pattern="^[A-Za-z]+$"
                            label={
                                <span>
                                    Last Name<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.last_name && (
                            <p className="error-message">{isFieldErrors.last_name}</p>
                        )}
                    </div>
                </div>
                <div className="form-group input-group login-form--item-left-form-input">
                    <Input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={isRegister.email}
                        onChange={registerHandler}
                        className="form-control"
                        label={
                            <span>
                                Email<span style={{ color: "red" }}>*</span>
                            </span>
                        }
                    />
                    {isFieldErrors.email && (
                        <p className="error-message">{isFieldErrors.email}</p>
                    )}
                </div>
                <div className="login-form--item-left-form-row">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <FormCountryCodes 
                            value={isRegister.country_code}
                            onChange={registerHandler}
                        />
                        {isFieldErrors.country_code && (
                            <p className="error-message">{isFieldErrors.country_code}</p>
                        )}
                    </div>

                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="phone"
                            placeholder="Phone No"
                            value={isRegister.phone}
                            onChange={registerHandler}
                            className="form-control"
                            pattern="^[0-9]*$"
                            minLength="8"
                            maxLength="14"
                            label={
                                <span>
                                    Phone No<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.phone && (
                            <p className="error-message">{isFieldErrors.phone}</p>
                        )}
                    </div>
                </div>
                <div className="login-form--item-left-form-row">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={isRegister.password}
                            onChange={registerHandler}
                            className="form-control"
                            label={
                                <span>
                                    Password<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.password && (
                            <p className="error-message">{isFieldErrors.password[0]}</p>
                        )}
                    </div>
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="password"
                            name="confirm_password"
                            placeholder="Confirm Password"
                            value={isRegister.confirm_password}
                            onChange={registerHandler}
                            className="form-control"
                            label={
                                <span>
                                    Confirm Password<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.confirm_password && (
                            <p className="error-message">{isFieldErrors.confirm_password}</p>
                        )}
                    </div>
                </div>
                
                <div className="form-group login-form--item-left-form-submit">
                    <button type="submit" name="submit" className="submit">
                        Submit
                    </button>
                </div>

            </form>

            <ConfirmationModal
                show={showModal}
                onClose={handleCloseModal}
                title="Registration Successful"
                body="Your account has been created successfully."
                className="modalshow"
                actions={[
                    {
                        label: "Submit",
                        onClick: handleCloseModal,
                        className: "btn-custom",
                    },
                ]}
            />
        </>
    );
};

export default FormRegister;
